
<div class="col text-center">
    <div class="row justify-content-center">
        <div class="dialog-title-box">
            <div class="col">
                <div class="row">
                    <div class="col pt-3">
                        <i [ngClass]="data.icon" class=" icon" id="questionIcon"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col pb-3 pt-3">
                        <span id="confirmation" class="title pb-1 mt-3 mb-3">
                            {{data.title}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<mat-dialog-content class="mat-typography mat-dialog-content mat-dialog-container-Edit">
<div class="col p-0">
    <h2 class="col maincontent pt-4 mb-1 text-center" id="confirmation">
        {{data.message}}
    </h2>

    <div class="form-group">
        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>InputBox</mat-label>
            <mat-select #select104 class="colorblack">
                <mat-option value="A" mat-dialog-close="A" (click)="SelectData('A')">All</mat-option>
                <mat-option value="L" mat-dialog-close="L" (click)="SelectData('L')">Last Input List</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
   
    <h2 class="col subcontent mb-2 text-center" id=""></h2>
</div>
<div class="col text-center pb-3">
    <div class="row">
        <div class="justify-content-center">
            <button mat-dialog-close="true" tabindex="1" type="button" id=""
                class="btn btn-primary  center-block w-70">
                Close
            </button>
        </div>
    </div>
</div>
</mat-dialog-content>